<!-- Created by Maxim B. on 10/05/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->
<div class="red-lbl-container">
  <div class="arrow-left"></div>
  <p>{{text}}</p>
</div>

